import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, Checkbox, Grid } from 'semantic-ui-react';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { resetForm } from 'State/forms/actions';
import { Filter, Main } from 'Containers';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { UsageEnum } from 'Common/FieldEnum';
import { USAGE_LIST_FORM_NAME } from 'Common/FormEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  PrintOptionsEnum,
  StatusEnum,
  StatusOptionEnum,
} from 'Common/Constants/Enumeration/UsageListEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { errorToast, toastSuccess } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { dateSortMethod } from 'Common/GridHelper';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';

import { clearUsageGridData } from '../../state/UsageList/actions';
import UsageList from '../../components/usageList/UsageList';
import { actions } from '../../state/actions';
import { basicURL } from '../../helper';
import * as UsageListSelectors from '../../state/UsageList/selectors';

import 'Styles/pages/inventory/transaction/usage/index.less';

class UsageListContainer extends Component {
  static propTypes = {
    allTableStates: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    resetForm: PropTypes.func.isRequired,
    clearUsageGridData: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    fromDateMax: PropTypes.object.isRequired,
    toDateMin: PropTypes.object.isRequired,
    deleteSuccessMsg: PropTypes.string,
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    deleteLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    usageListDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printData: PropTypes.string.isRequired,
    usageListData: PropTypes.array.isRequired,
  };
  static defaultProps = {
    beginDT: moment()
      .subtract(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    endDT: moment()
      .add(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    site: '0',
    printOptions: PrintOptionsEnum.ItemCode,
    viewStatusOptions: StatusEnum.Open,
    deleteSuccessMsg: '',
  };
  constructor(props) {
    super(props);
    const currentDate = moment();
    this.reactTableRef = React.createRef();
    this.state = {
      fromDateMax: currentDate,
      toDateMin: null,
      showDeleteModel: false,
      showDeleteConfirm: false,
      selectedUsages: [],
      columns: [
        {
          Header: currentRows => {
            const { selectedUsages } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, obj => {
              const id = obj[UsageEnum.Id]
                ? obj[UsageEnum.Id]
                : obj._original[UsageEnum.Id];
              if (selectedUsages.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    e.stopPropagation();

                    if (checked) {
                      this.setState({
                        selectedUsages: [
                          ...this.state.selectedUsages,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedUsages];
                      _.forEach(dataObjs, obj => {
                        const id = obj[UsageEnum.Id]
                          ? obj[UsageEnum.Id]
                          : obj._original[UsageEnum.Id];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({
                        selectedUsages: copySelected,
                      });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: UsageEnum.Allowed,
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            const { selectedUsages } = this.state;
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    selectedUsages.indexOf(original[UsageEnum.Id]) !== -1
                  }
                  onChange={(e, { checked }) => {
                    this.checkCurrentRow(original, checked);
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Usage #',
          accessor: UsageEnum.Id,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Id',
          accessor: UsageEnum.SiteId,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Name',
          accessor: UsageEnum.SiteDescription,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Usage Date',
          accessor: UsageEnum.UsageDT,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Status',
          accessor: UsageEnum.Status,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Comments',
          accessor: UsageEnum.Comments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(gridProps),
            });
          },
        },
      ],
    };
  }

  componentDidMount() {
    const {
      beginDT,
      endDT,
      site,
      viewStatusOptionsValue,
      initialValues,
    } = this.props;
    const fetchData = {
      SiteId: site ? site : initialValues[UsageEnum.Site],
      Status: viewStatusOptionsValue
        ? viewStatusOptionsValue === StatusEnum.All
          ? ''
          : viewStatusOptionsValue === StatusEnum.Open
            ? StatusOptionEnum.OPEN
            : StatusOptionEnum.CLOSED
        : StatusOptionEnum.OPEN,
      DateFrom: beginDT
        ? moment(beginDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .subtract(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      DateTo: endDT
        ? moment(endDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .add(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
    };
    this.props.getUsageData(fetchData);
  }

  componentDidUpdate(prevProps) {
    const { printData, clearUsageError } = this.props;

    if (
      errorToast(this.props, prevProps, 'deleteLoadingError') ||
      errorToast(this.props, prevProps, 'usageListDataError')
    ) {
      clearUsageError();
    } else if (!prevProps.deleteSuccessMsg && this.props.deleteSuccessMsg) {
      toastSuccess(this.props.deleteSuccessMsg);
      clearUsageError();
    }
    if (printData && prevProps.printData !== this.props.printData) {
      ReportGeneration(printData, 'Usage Report');
    }
  }

  componentWillUnmount() {
    this.props.clearUsageGridData();
    this.clearTableSavedState();
    this.setState({ selectedUsages: [] });
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.USAGE_LIST_TABLE,
      TableNamesEnum.USAGE_LIST_CREATE_EDIT_TABLE,
    ]);
  };

  getMenuOptions = gridProps => {
    const { row } = gridProps;

    const selectedIds = this.getFilteredSelectedUsage();
    if (selectedIds.length <= 1)
      return [
        {
          icon: 'pencil',
          text: row && row.Status === StatusEnum.Closed ? 'View' : 'View/Edit',
          handler: this.onEditClick,
        },
        {
          icon: 'trash',
          text: 'Delete',
          className: 'danger',
          disabledWhen: row => row.Status === StatusEnum.Closed,
          handler: this.onDeleteClick,
        },
      ];

    return [
      {
        icon: 'trash',
        text: 'Delete All',
        className: 'danger',
        disabledWhen: row => row.Status === StatusEnum.Closed,
        handler: this.onDeleteClick,
      },
    ];
  };

  getFilterData = (beginDT, endDT, site, statusOption) => {
    let statusFilter =
      statusOption === StatusEnum.All
        ? ''
        : statusOption === StatusEnum.Open
          ? StatusOptionEnum.OPEN
          : StatusOptionEnum.CLOSED;

    const fetchData = {
      SiteId: site,
      Status: statusFilter,
      DateFrom: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
      DateTo: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
    };
    this.props.getUsageData(fetchData);
  };

  setSelectedSite = (newValue, preValue) => {
    if (newValue !== preValue) {
      const { beginDT, endDT, viewStatusOptionsValue } = this.props;
      this.getFilterData(beginDT, endDT, newValue, viewStatusOptionsValue);
      this.setState({ selectedUsages: [] });
    }
  };

  onChangeOfFromDT = (e, beginDate) => {
    this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate) => {
    this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    const { site, endDT, viewStatusOptionsValue, setToDateMin } = this.props;
    setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDate, endDT, site, viewStatusOptionsValue);
    this.setState({ selectedUsages: [] });
  };

  selectToDate = (e, endDate) => {
    const {
      site,
      beginDT,
      viewStatusOptionsValue,
      setFromDateMax,
    } = this.props;
    setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDT, endDate, site, viewStatusOptionsValue);
    this.setState({ selectedUsages: [] });
  };
  getFilteredSelectedUsage = () => {
    const { usageListData } = this.props;
    const { selectedUsages } = this.state;
    const checkedUsageOrders = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: usageListData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[UsageEnum.Id]
        ? obj[UsageEnum.Id]
        : obj._original[UsageEnum.Id];
      if (selectedUsages.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  printUsage = () => {
    const { usageListData } = this.props;
    const checkedUsageOrders = this.getFilteredSelectedUsage();
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: usageListData };
    if (
      checkedUsageOrders &&
      !checkedUsageOrders.length &&
      dataObjs.sortedData.length
    ) {
      checkedUsageOrders[0] = dataObjs.sortedData[0][UsageEnum.Id];
    }

    const printOptions = {
      SortType:
        this.props.printOptionsValue === PrintOptionsEnum.ItemCode ? 0 : 1,
      TransactionIds: checkedUsageOrders,
    };

    checkedUsageOrders.length && this.props.getPrintUsageData(printOptions);
  };

  setShowStatusOption = value => {
    const { site, beginDT, endDT } = this.props;
    this.getFilterData(beginDT, endDT, site, value);
    this.setState({ selectedUsages: [] });
  };

  clearFilters = () => {
    const { initialValues, setToDateMin, setFromDateMax } = this.props;
    setFromDateMax(moment().add(1, 'month'));
    setToDateMin(moment().subtract(1, 'month'));
    this.getFilterData(
      initialValues[UsageEnum.BeginDT],
      initialValues[UsageEnum.EndDT],
      initialValues[UsageEnum.Site],
      initialValues[UsageEnum.ViewStatusOptions]
    );
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(USAGE_LIST_FORM_NAME);
  };

  onDeleteClick = row => {
    const { usageListData } = this.props;
    const { selectedUsages } = this.state;
    let usageIds = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: usageListData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[UsageEnum.Id]
        ? obj[UsageEnum.Id]
        : obj._original[UsageEnum.Id];
      if (selectedUsages.indexOf(id) !== -1) {
        usageIds.push(id);
      }
    });
    if (!selectedUsages.length) {
      usageIds.push(row[UsageEnum.Id]);
    }

    let selectedStatus = _.filter(
      usageListData,
      usage =>
        usageIds.indexOf(usage[UsageEnum.Id]) !== -1 &&
        usage.Status === StatusEnum.Closed
    );

    if (selectedStatus.length) {
      this.setState({
        showDeleteConfirm: !this.state.showDeleteConfirm,
      });
      return;
    }

    this.setState({
      selectedOrder: usageIds.length > 1 ? usageIds : usageIds[0],
      showDeleteModel: !this.state.showDeleteModel,
    });
  };

  closeDeleteOrderConfirm = () => {
    this.setState({
      showDeleteConfirm: !this.state.showDeleteConfirm,
    });
  };

  handleDeleteDialog = result => {
    const {
      beginDT,
      endDT,
      site,
      viewStatusOptionsValue,
      usageListData,
    } = this.props;
    const { selectedUsages } = this.state;
    if (result) {
      let orderList = [];
      const dataObjs =
        this.reactTableRef && this.reactTableRef.current
          ? this.reactTableRef.current.getResolvedState()
          : { sortedData: usageListData };
      _.forEach(dataObjs.sortedData, obj => {
        const id = obj[UsageEnum.Id]
          ? obj[UsageEnum.Id]
          : obj._original[UsageEnum.Id];
        if (selectedUsages.indexOf(id) !== -1) {
          orderList.push(id);
        }
      });
      if (!orderList.length) {
        orderList[0] = this.state.selectedOrder;
      }

      this.props.deleteUsage(orderList).then(() => {
        this.getFilterData(beginDT, endDT, site, viewStatusOptionsValue);
        this.setState({ selectedUsages: [] });
      });
    }
    this.setState({ showDeleteModel: false });
  };

  onAddClick = () => {
    this.props.history.push('/usage/0/0');
  };

  onEditClick = row => {
    this.props.history.push(`/usage/1/${row.Id}`);
  };

  handleClick = (e, titleProps) => {
    const { index, option } = titleProps;
    const { activeIndexForFilter, activeIndexForSort } = this.state;
    const newIndex = !option
      ? activeIndexForFilter === index
        ? -1
        : index
      : activeIndexForSort === index
        ? -1
        : index;
    !option
      ? this.setState({
          activeIndexForFilter: newIndex,
        })
      : this.setState({
          activeIndexForSort: newIndex,
        });
  };
  checkCurrentRow = (original, checked) => {
    let value = [...this.state.selectedUsages];
    checked
      ? value.indexOf(original[UsageEnum.Id]) === -1 &&
        value.push(original[UsageEnum.Id])
      : value.indexOf(original[UsageEnum.Id]) !== -1 &&
        value.splice(value.indexOf(original[UsageEnum.Id]), 1);

    this.setState({ selectedUsages: value });
  };

  render() {
    const {
      columns,
      showDeleteModel,
      showDeleteConfirm,
      selectedOrder,
      activeIndexForFilter,
      activeIndexForSort,
    } = this.state;
    const {
      usageListData,
      gridPreferenceSubmitting,
      gridPreferenceLoading,
      loading,
      printLoading,
      fromDateMax,
      toDateMin,
    } = this.props;
    return (
      <Fragment>
        <Filter title={'Usage'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <UsageList
            columns={columns}
            reactTableRef={this.reactTableRef}
            usageListData={usageListData}
            setSelectedSite={this.setSelectedSite}
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            onChangeOfToDT={this.onChangeOfToDT}
            toDateMin={toDateMin}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            gridPreferenceLoading={gridPreferenceLoading}
            loading={loading}
            setPrintTypeOption={this.setPrintTypeOption}
            printUsage={this.printUsage}
            setShowStatusOption={this.setShowStatusOption}
            clearFilters={this.clearFilters}
            showDeleteModel={showDeleteModel}
            handleDeleteDialog={this.handleDeleteDialog}
            showDeleteConfirm={showDeleteConfirm}
            closeDeleteOrderConfirm={this.closeDeleteOrderConfirm}
            selectedUsageRecord={selectedOrder}
            printLoading={printLoading}
            activeIndexForFilter={activeIndexForFilter}
            activeIndexForSort={activeIndexForSort}
            handleClick={this.handleClick}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(USAGE_LIST_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(USAGE_LIST_FORM_NAME)(state));
  return {
    beginDT: selector(state, UsageEnum.BeginDT),
    endDT: selector(state, UsageEnum.EndDT),
    site: selector(state, UsageEnum.Site),
    printOptionsValue: selector(state, UsageEnum.PrintOptions),
    viewStatusOptionsValue: selector(state, UsageEnum.ViewStatusOptions),
    initialValues: {
      [UsageEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [UsageEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [UsageEnum.Site]: '0',
      [UsageEnum.PrintOptions]: PrintOptionsEnum.ItemCode,
      [UsageEnum.ViewStatusOptions]: StatusEnum.Open,
    },
    allTableStates: getTableStates(state),

    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),

    usageListData: UsageListSelectors.getUsageListData(state),
    loading: UsageListSelectors.getLoading(state),
    printLoading: UsageListSelectors.getPrintLoading(state),
    printError: UsageListSelectors.getPrintError(state),
    fromDateMax: UsageListSelectors.getFromDateMax(state),
    toDateMin: UsageListSelectors.getToDateMin(state),
    deleteLoadingError: UsageListSelectors.getDeleteLoadingError(state),
    deleteSuccessMsg: UsageListSelectors.getDeleteSuccessMsg(state),
    usageListDataError: UsageListSelectors.getUsageListDataError(state),
    printData: UsageListSelectors.getPrintData(state),
  };
};

UsageListContainer = reduxForm({
  destroyOnUnmount: false,
  form: USAGE_LIST_FORM_NAME,
})(UsageListContainer);

const mapDispatchToProps = {
  ...actions,
  resetForm,
  clearUsageGridData,
  setTableStates,
};
export const Usage = connect(
  mapStateToProps,
  mapDispatchToProps
)(UsageListContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/containers/usageList/UsageListContainer.js